import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'

import IndexRedirect from './IndexRedirect'
import OpponentKeyLoader from './OpponentKeyLoader'
import BeatThePro from './pages/BeatThePro'
import Leaderboard from './pages/Leaderboard'
import PokerPayouts from './pages/PokerPayouts'
import PokerSeat from './pages/PokerSeat'
import Profile from './pages/Profile'
import Score from './pages/Score'
import Scorecard from './pages/Scorecard'
import SideGames from './pages/SideGames'
import Stack from './pages/Stack'
import PlayerKeyLoader from './PlayerKeyLoader'
import PlayerShell from './PlayerShell'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <main className="min-h-dvh flex flex-col items-center justify-center px-6 text-center">
        <p className="up text-ink-500">POLF · Player</p>
        <h1 className="font-display font-extrabold text-3xl tracking-tight text-green-900 mt-2">
          Spillerlenke mangler
        </h1>
        <p className="font-sans text-base text-ink-700 mt-3 max-w-md">
          Åpne lenken du fikk på SMS for å komme inn i turneringen.
        </p>
      </main>
    ),
  },
  {
    path: '/s/:playerKey',
    element: <PlayerKeyLoader />,
    children: [
      {
        element: <PlayerShell />,
        children: [
          { index: true, element: <IndexRedirect /> },
          { path: 'score', element: <Score /> },
          { path: 'scorecard', element: <Scorecard /> },
          { path: 'leaderboard', element: <Leaderboard /> },
          { path: 'sidegames', element: <SideGames /> },
          { path: 'poker', element: <PokerSeat /> },
          { path: 'payouts', element: <PokerPayouts /> },
          { path: 'stack', element: <Stack /> },
          { path: 'profile', element: <Profile /> },
        ],
      },
    ],
  },
  {
    // Public Beat-the-Pro audience view (the pro's SMS link → /b/:key).
    path: '/b/:opponentKey',
    element: <OpponentKeyLoader />,
    children: [
      { index: true, element: <BeatThePro /> },
      { path: 'beatthepro', element: <BeatThePro /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])

const App = () => <RouterProvider router={router} />

export default App
